<template>
  <div class="h-100">
    <Navbar />
    <router-view v-slot="slotProps">
      <transition name="route" mode="out-in">
        <component :is="slotProps.Component"></component>
      </transition>
    </router-view>
  </div>
</template>

<script>
import router from "../router";
import Navbar from "./Navbar.vue";
export default {
  components: { Navbar },

  data() {
    return {
      showSidebar: false,
      gameOver: null,
      hoursLeft: null,
      account: null,
      currentRoute: null,
      expiredDate: null,
      winningToken: 0,
    };
  },
  mounted() {
    // validate session on mounting page
    if (!localStorage.getItem("wax_user")) {
      router.push("/login");
    }
  },
  methods: {
    showSide: function () {
      this.showSidebar = !this.showSidebar;
    },
    logout: function () {
      router.push("/login");
    },
  },
};
</script>
